import React from "react";
import moment from "moment";
import { formatUnitsForReport, mapUnits } from "../../../../helpers/units";

export const columnsPurchase = (
  props,
  loadPurchaseDetails,
  selectedRow,
  selectFilter,
  dynamicSort,
  is_requested = false
) => {
  return [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadPurchaseDetails(row.item_id,is_requested);
            }}
          >
            {row.name} <span hidden={!row.is_free} className="text-danger" style={{fontSize:"20px"}}>*</span>
            </span>
        );
      },
    },
    // {
    //   text: props.t("Category"),
    //   dataField: "category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               selectedRow?.map(({ category: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Total Received"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.received_quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "cost_price",
    //   text: props.t("Price (QR)"),
    //   formatter: (cell, row) => {
    //     // return row?.cost_price + "/" + row?.unit_for_po;
    //     return row?.cost_price ;
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },

    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return Number(row.receiving_cost.toFixed(2));
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
  ];
};
export const columnsPurchaseDetails = (props, selectFilter) => {
  return [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "delivery_details.seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "delivery_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      formatter: (cell, row) => {
        return (
          <div>
            <div>{cell}</div>
            {row.po_id  && (
              <small>
                <a
                  href={"/purchase_order?po_id=" + row._id}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-info"
                >
                  PO: {row.po_id}
                </a>
              </small>
            )}
          </div>
        );
      }
    },
    {
      dataField: "delivery_details.unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.delivery_details?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },

    {
      dataField: "unit",
      text: props.t("Received Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.delivery_details.receive);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "dd_is_free",
      text: props.t("Free ?"),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
      }),
    },
    {
      dataField: "delivery_details.unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "delivery_details.cost_price",
      text: props.t("Price (QR)"),
      formatter: (cell, row) => {
        if (row?.delivery_details?.is_free) {
          return (row?.delivery_details?.free_cost_price);
        } else {
          return (row?.delivery_details?.cost_price);
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "delivery_details.receiving_cost",
      text: props.t("Receiving Cost"),
      formatter: (cell, row) => {
        if (row?.delivery_details?.is_free) {
          return (
            <div>
              <div>Projected: {row?.delivery_details?.projected_cost}</div>
            </div>
          );
        } else {
          return `${row?.delivery_details?.receiving_cost}`;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "receiving_datetime",
      text: props.t("Date"),
      formatter: (cell, row) => {
        return moment(row.receiving_datetime).format("DD/MM/YYYY HH:mm");
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
  ];
};

export const columnsOpeningDetails = (props, selectFilter) => {
  return [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },
    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "20%" };
      },
      formatter: (cell, row) => {
        return (
          <div>
                        {cell} <span hidden={!row.is_free} className="text-danger" style={{fontSize:"20px"}}>*</span>
            {/* {row.po_id  && (
              <small>
                <a
                  href={"/purchase_order?po_id=" + row._id}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-info"
                >
                  PO: {row.po_id}
                </a>
              </small>
            )} */}
          </div>
        );
      }
    },
    {
      dataField: "unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
{
      dataField: "batch",
      text: props.t("Batch"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "unit",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "is_free",
      text: props.t("Free ?"),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
      }),
    },
    {
      dataField: "unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    },
    {
      dataField: "cost_price",
      text: props.t("Price (QR)"),
      formatter: (cell, row) => {
        if (row?.is_free) {
          return (row?.free_cost_price);
        } else {
          return (row?.cost_price);
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
    {
      dataField: "total_cost",
      text: props.t("Total Cost"),
      formatter: (cell, row) => {
        if (row?.is_free) {
          return (
            <div>
              <div>{row?.projected_cost}</div>
            </div>
          );
        } else {
          return `${Number(row?.total_cost.toFixed(2))}`;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
    }
  ];
};
export const columnsItemOutbound = (
  props,
  loadItemOutboundDetails,
  selectFilter,
  selectedBranch,
  dynamicSort
) => {
  return [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "22%" };
      },
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className={`${selectedBranch.type ==="Branch" ? `text-info mr-2` : ``}`}
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              if(selectedBranch.type !=="Branch") return
              loadItemOutboundDetails(row.item_id);
            }}
          >
            {row.name} <span hidden={!row.is_free} className="text-danger" style={{fontSize:"20px"}}>*</span>
            </span>
        );
      },
    },
    {
      dataField: "source",
      text: props.t("Source"),
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
      hidden: selectedBranch.type === "Branch" ? true : false,
    },

    // {
    //   text: props.t("Category"),
    //   dataField: "category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               selectedRow?.map(({ category: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    {
      dataField: "name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "12%" };
      },
    },
    //  {
    //         dataField: "is_free",
    //         text: props.t("Free ?"),
    //         sort: true,
    //         headerStyle: (colum, colIndex) => {
    //           return { width: "10%" };
    //         },
    //         formatter: cell => (
    //           cell ? 'Yes' : 'No'
    //         ),
    //         filter: selectFilter({
    //           options: [
    //             { value: true, label: "Yes" },
    //             { value: false, label: "No" }
    //           ],
    //           placeholder: "All"
    //         })
    //       },
    {
      dataField: "unit",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
    // {
    //   dataField: "cost_price",
    //   text: props.t("Price (QR)"),
    //   formatter: (cell, row) => {
    //     // return row?.cost_price + "/" + row?.unit_for_po;
    //     return row?.cost_price ;
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    // },

    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return Number(row.receiving_cost.toFixed(2));
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
    },
  ];
};
export const columnsItemOutboundDetails = (
  props,
  selectFilter,
  itemOutboundDetails,
  dynamicSort
) => {
  return [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_details.seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Item"),
      dataField: "item_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
      formatter: (cell, row) => {
        let po_id = row.item_details?.po_id
        return (
          <div>
            <div>{cell}</div>
            {po_id && (
              <small>
                <a
                  href={"/purchase_order?po_id=" + po_id}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-info"
                >
                  PO: {po_id}
                </a>
              </small>
            )}
          </div>
        );
      }
    },
    // {
    //   text: props.t("Category"),
    //   dataField: "item_details.category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               itemOutboundDetails?.map(({ category: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    {
      dataField: "branch_to.name",
      text: props.t("Branch To"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "item_details.name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.item_details?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "id_is_free",
      text: props.t("Free ?"),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
      }),
    },
    {
      dataField: "item_details.name",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.item_details.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "item_details.unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "item_details.cost_price",
      text: props.t("Price (QR)"),
      // formatter: (cell,row)=>{
      //   return row?.item_details.cost_price + "/" + row?.item_details.unit_for_po
      //  },
      formatter: (cell, row) => {
        if (row?.item_details?.is_free) {
          return (row?.item_details.free_cost_price);
        } else {
          return (row?.item_details.cost_price);
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      dataField: "item_details.receiving_cost",
      text: props.t("Total Cost (QR)"),
      formatter: (cell, row) => {
        if (row?.item_details?.is_free) {
          return (
            <div>
              <div>Projected: {row?.item_details.projected_cost}</div>
            </div>
          );
        } else {
          return `${row?.item_details.receiving_cost}`;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];
};
export const columnsItemInbound = (
  props,
  loadItemInboundDetails,
  selectFilter,
  selectedRow,
  dynamicSort
) => {
  return [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Item"),
      dataField: "name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "22%" };
      },
      formatter: (cell, row, rowIndex) => {
        return (
          <span
            className="text-info mr-2"
            title="View Details"
            style={{ cursor: "pointer" }}
            onClick={() => {
              loadItemInboundDetails(row.item_id);
            }}
          >
            {row.name} <span hidden={!row.is_free} className="text-danger" style={{fontSize:"20px"}}>*</span>
            </span>
        );
      },
    },
    // {
    //   text: props.t("Category"),
    //   dataField: "category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               selectedRow?.map(({ category: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    {
      dataField: "name",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "is_free",
      text: props.t("Free ?"),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
      }),
    },
    {
      dataField: "unit",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return formatUnitsForReport(row.quantity);
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    // {
    //   dataField: "cost_price",
    //   text: props.t("Price (QR)"),
    //   formatter: (cell, row) => {
    //     // return row?.cost_price + "/" + row?.unit_for_po;
    //     return row?.cost_price;
    //   },
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "8%" };
    //   },
    // },

    {
      dataField: "receiving_cost",
      text: props.t("Total Cost (QR)"),
      sort: true,
      formatter: (cell, row, rowIndex) => {
        return Number(row.receiving_cost.toFixed(2));
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];
};
export const columnsItemInboundDetails = (
  props,
  selectFilter,
  itemInboundDetails,
  dynamicSort
) => {
  return [
    {
      dataField: "item_id",
      hidden: true,
    },
    {
      dataField: "item_details.seq_no",
    //   formatter: (cell, row, rowIndex) => {
    //     return rowIndex + 1;
    //   },
      text: props.t("S.N"),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
    },

    {
      text: props.t("Item"),
      dataField: "item_details.name",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "18%" };
      },
      formatter: (cell, row) => {
        let po_id = row.item_details?.po_id
        return (
          <div>
            <div>{cell}</div>
            {po_id && (
              <small>
                <a
                  href={"/purchase_order?po_id=" + po_id}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-info"
                >
                  PO: {po_id}
                </a>
              </small>
            )}
          </div>
        );
      }
    },
    // {
    //   text: props.t("Category"),
    //   dataField: "item_details.category",
    //   sort: true,
    //   headerStyle: (colum, colIndex) => {
    //     return { width: "10%" };
    //   },
    //   filter: selectFilter({
    //     options: () => {
    //       const unique = [
    //         ...new Map(
    //           [
    //             ...new Set(
    //               itemInboundDetails?.map(({ category: value }) => ({
    //                 value: value,
    //                 label: value,
    //               }))
    //             ),
    //           ].map((item) => [item["value"], item])
    //         ).values(),
    //       ];

    //       unique.sort(dynamicSort("label"));
    //       return unique;
    //     },
    //   }),
    // },
    {
      dataField: "branch_from.name",
      text: props.t("Branch From"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "item_details.unit_levels",
      text: props.t("Formula"),
      sort: true,
      formatter: (cell, row) => {
        return mapUnits(row?.item_details.unit_levels);
      },
      headerStyle: (colum, colIndex) => {
        return { width: "14%" };
      },
    },
    {
      dataField: "id_is_free",
      text: props.t("Free ?"),
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      formatter: (cell) => (cell ? "Yes" : "No"),
      filter: selectFilter({
        options: [
          { value: true, label: "Yes" },
          { value: false, label: "No" },
        ],
        placeholder: "All",
      }),
    },
    {
      dataField: "item_details.name",
      text: props.t("Quantity"),
      formatter: (cell, row) => {
        return row.item_details.quantity.length>0  ? formatUnitsForReport(row.item_details.quantity) : "Yet To Receive";
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "13%" };
      },
    },
    {
      dataField: "item_details.unit_for_po",
      text: props.t("Purchasing Unit"),
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
    },
    {
      dataField: "item_details.cost_price",
      text: props.t("Price (QR)"),
      // formatter: (cell,row)=>{
      //   return row?.item_details.cost_price + "/" + row?.item_details.unit_for_po
      //  },
      formatter: (cell, row) => {
        if (row?.item_details?.is_free) {
          return (row?.item_details.free_cost_price);
        } else {
          return (row?.item_details.cost_price);
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },

    {
      dataField: "item_details.receiving_cost",
      text: props.t("Total Cost (QR)"),
      formatter: (cell, row) => {
        if (row?.item_details?.is_free) {
          return (
            <div>
              <div>Projected: {row?.item_details?.projected_cost}</div>
            </div>
          );
        } else {
          return `${row?.item_details.receiving_cost}`;
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
    },
  ];
};
export const columnsItem = (props,selectFilter,loadItemDetails,selectedRow,dynamicSort) => {
    return [
        {
          dataField: "item_id",
          hidden: true,
        },
        {
          dataField: "seq_no",
        //   formatter: (cell, row, rowIndex) => {
        //     return rowIndex + 1;
        //   },
          text: props.t("S.N"),
          headerStyle: (colum, colIndex) => {
            return { width: "5%" };
          },
        },
    
        {
          text: props.t("Item"),
          dataField: "name",
          formatter: (cell, row, rowIndex) => {
            return (
              <span
                className="text-info mr-2"
                title="View Details"
                style={{ cursor: "pointer" }}
                onClick={() => {
                  loadItemDetails(row.item_id);
                }}
              >
            {row.name} <span hidden={!row.is_free} className="text-danger" style={{fontSize:"20px"}}>*</span>
            </span>
            );
          },
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "20%" };
          },
        },
        // {
        //   text: props.t("Category"),
        //   dataField: "category",
        //   sort: true,
        //   headerStyle: (colum, colIndex) => {
        //     return { width: "12%" };
        //   },
        //   filter: selectFilter({
        //     options: () => {
        //       const unique = [
        //         ...new Map(
        //           [
        //             ...new Set(
        //               selectedRow.map(({ category: value }) => ({
        //                 value: value,
        //                 label: value,
        //               }))
        //             ),
        //           ].map((item) => [item["value"], item])
        //         ).values(),
        //       ];
    
        //       unique.sort(dynamicSort("label"));
        //       return unique;
        //     },
        //   }),
        // },
        {
          dataField: "name",
          text: props.t("Formula"),
          sort: true,
          formatter: (cell,row)=>{
            return mapUnits(row?.unit_levels)
          },
          headerStyle: (colum, colIndex) => {
            return { width: "13%" };
          },
        },
    
        {
          dataField: "received_quantity",
          text: props.t("Received Quantity"),
          formatter: (cell, row) => {
            return formatUnitsForReport(row.received_quantity)
          },
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "13%" };
          },
        },
        {
          dataField: "unit_for_po",
          text: props.t("Purchasing Unit"),
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "10%" };
          },
        },
        // {
        //   dataField: "cost_price",
        //   text: props.t("Price (QR)"),
        //   formatter: (cell,row)=>{
        //     // return row?.cost_price + "/" + row?.unit_for_po
        //     return row?.cost_price
        //    },
        //   sort: true,
        //   headerStyle: (colum, colIndex) => {
        //     return { width: "6%" };
        //   },
        // },
        {
          dataField: "receiving_cost",
          text: props.t("Total Cost (QR)"),
          formatter: (cell, row, rowIndex) => {
            return Number(row.receiving_cost.toFixed(2));
          },
          sort: true,
          headerStyle: (colum, colIndex) => {
            return { width: "10%" };
          },
        },
      ];
 }
export const columnsItemDetails = (props,selectFilter,monthYear) =>{
    return [
       {
             dataField: "_id",
             hidden: true,
           },
           {
            dataField: "delivery_details.seq_no",
          //   formatter: (cell, row, rowIndex) => {
          //     return rowIndex + 1;
          //   },
            text: props.t("S.N"),
            headerStyle: (colum, colIndex) => {
              return { width: "5%" };
            },
          },
           {
             text: props.t("Item"),
             dataField: "delivery_details.name",
             sort: true,
             headerStyle: (colum, colIndex) => {
               return { width: "25%" };
             },
             formatter: (cell, row) => {
              let po_id = row.delivery_details?.po_id
              let order_id = row?.order_id;
              const params = `?month=${monthYear}&order_id=${order_id}`;
              return (
                <div>
                  <div>{cell}</div>
                  {po_id &&  (
                    <small className="me-1">
                      <a
                        href={"/purchase_order?po_id=" + po_id}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-info"
                      >
                        PO: {po_id}
                      </a>
                    </small> 
                  )} |
                   {order_id &&  (
          <small className="ml-1">
            <a
              href={`/items/closed_orders${params}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-info"
            >
              Order: {order_id}
            </a>
          </small>
        )}
                </div>
              );
            }
           },
           {
             dataField: "delivery_details.unit_levels",
             text: props.t("Formula"),
             sort: true,
             formatter: (cell,row)=>{
               return mapUnits(row.delivery_details?.unit_levels)
             },
             headerStyle: (colum, colIndex) => {
               return { width: "13%" };
             },
           },
       
           {
             dataField: "unit",
             text: props.t("Received Quantity"),
             formatter: (cell, row) => {
               return row.delivery_details?.is_received ? formatUnitsForReport(row.delivery_details.received_quantity) : "Yet To Receive"
             },
             sort: true,
             headerStyle: (colum, colIndex) => {
               return { width: "15%" };
             },
             },
             {
               dataField: "dd_is_free",
               text: props.t("Free ?"),
               sort: true,
               headerStyle: (colum, colIndex) => {
                 return { width: "8%" };
               },
               formatter: cell => (
                 cell ? 'Yes' : 'No'
               ),
               filter: selectFilter({
                 options: [
                   { value: true, label: "Yes" },  
                   { value: false, label: "No" }   
                 ],
                 placeholder: "All"
               })
             },
             {
              dataField: "delivery_details.unit_for_po",
              text: props.t("Purchasing Unit"),
              sort: true,
              headerStyle: (colum, colIndex) => {
                return { width: "10%" };
              },
            },
           {
             dataField: "delivery_details.cost_price",
             text: props.t("Price (QR)"),
             // formatter: (cell,row)=>{
             //   return row?.delivery_details.cost_price + "/" + row?.delivery_details?.unit_for_po
             //  },
              formatter: (cell, row) => {
               if (row?.delivery_details?.is_free) {
                 return (row?.delivery_details?.free_cost_price);
               } else {
                 return row?.delivery_details?.cost_price
               }
             },
             sort: true,
             headerStyle: (colum, colIndex) => {
               return { width: "8%" };
             },
           },
           {
             dataField: "delivery_details.receiving_cost",
             text: props.t("Receiving Cost"),
             formatter: (cell, row) => {
               if (row?.delivery_details?.is_free) {
                 return (
                   <div>
                     <div>Projected: {row?.delivery_details.projected_cost}</div>
                   </div>
                 );
               } else {
                 return row?.delivery_details.receiving_cost
               }
             },
             sort: true,
             headerStyle: (colum, colIndex) => {
               return { width: "8%" };
             },
           },
       
           {
             dataField: "delivery_details.date_of_transaction",
             text: props.t("Date"),
             formatter: (cell, row) => {
               return moment(row.delivery_details.date_of_transaction).format(
                 "DD/MM/YYYY HH:mm"
               );
             },
             sort: true,
             headerStyle: (colum, colIndex) => {
               return { width: "14%" };
             },
           },
      ];
}
export const columnsFreeGoods = (props,loadFreeGoodsDetails) => {
  return [
      {
        dataField: "item_id",
        hidden: true,
      },
      {
        dataField: "seq_no",
      //   formatter: (cell, row, rowIndex) => {
      //     return rowIndex + 1;
      //   },
        text: props.t("S.N"),
        headerStyle: (colum, colIndex) => {
          return { width: "5%" };
        },
      },
  
      {
        text: props.t("Item"),
        dataField: "name",
        formatter: (cell, row, rowIndex) => {
          return (
            <span
              className="text-info mr-2"
              title="View Details"
              style={{ cursor: "pointer" }}
              onClick={() => {
                loadFreeGoodsDetails(row.item_id);
              }}
            >
          {row.name} <span hidden={!row.is_free} className="text-danger" style={{fontSize:"20px"}}>*</span>
          </span>
          );
        },
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "20%" };
        },
      },
      {
        text: props.t("Category"),
        dataField: "category",
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "12%" };
        },
        // filter: selectFilter({
        //   options: () => {
        //     const unique = [
        //       ...new Map(
        //         [
        //           ...new Set(
        //             selectedRow.map(({ category: value }) => ({
        //               value: value,
        //               label: value,
        //             }))
        //           ),
        //         ].map((item) => [item["value"], item])
        //       ).values(),
        //     ];
  
        //     unique.sort(dynamicSort("label"));
        //     return unique;
        //   },
        // }),
      },
      {
        dataField: "name",
        text: props.t("Formula"),
        sort: true,
        formatter: (cell,row)=>{
          return mapUnits(row?.unit_levels)
        },
        headerStyle: (colum, colIndex) => {
          return { width: "13%" };
        },
      },
  
      {
        dataField: "received_quantity",
        text: props.t("Quantity"),
        formatter: (cell, row) => {
          return formatUnitsForReport(row.quantity)
        },
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "13%" };
        },
      },
      {
        dataField: "unit_for_po",
        text: props.t("Purchasing Unit"),
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "10%" };
        },
      },
      // {
      //   dataField: "cost_price",
      //   text: props.t("Price (QR)"),
      //   formatter: (cell,row)=>{
      //     // return row?.cost_price + "/" + row?.unit_for_po
      //     return row?.cost_price
      //    },
      //   sort: true,
      //   headerStyle: (colum, colIndex) => {
      //     return { width: "6%" };
      //   },
      // },
      {
        dataField: "projected_cost",
        text: props.t("Total Cost (QR)"),
        formatter: (cell, row, rowIndex) => {
          return Number(row.projected_cost);
        },
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { width: "10%" };
        },
      },
    ];
}
export const columnFreeGoodsDetails = (props) =>{
  return [
     {
           dataField: "_id",
           hidden: true,
         },
         {
          dataField: "seq_no",
        //   formatter: (cell, row, rowIndex) => {
        //     return rowIndex + 1;
        //   },
          text: props.t("S.N"),
          headerStyle: (colum, colIndex) => {
            return { width: "5%" };
          },
        },
         {
           text: props.t("Item"),
           dataField: "name",
           sort: true,
           headerStyle: (colum, colIndex) => {
             return { width: "25%" };
           },
           formatter: (cell, row) => {
            return (
              <div>
                <div>{cell}</div>
                {row.po_id && (
                  <small>
                    <a
                      href={"/purchase_order?po_id=" + row.po_id}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-info"
                    >
                      PO: {row.po_id}
                    </a>
                  </small>
                )}
              </div>
            );
          }
         },
         {
           dataField: "unit_levels",
           text: props.t("Formula"),
           sort: true,
           formatter: (cell,row)=>{
             return mapUnits(row.unit_levels)
           },
           headerStyle: (colum, colIndex) => {
             return { width: "13%" };
           },
         },
     
         {
           dataField: "unit",
           text: props.t("Quantity"),
           formatter: (cell, row) => {
             return formatUnitsForReport(row.quantity)
          },
           sort: true,
           headerStyle: (colum, colIndex) => {
             return { width: "15%" };
           },
           },
           {
            dataField: "unit_for_po",
            text: props.t("Purchasing Unit"),
            sort: true,
            headerStyle: (colum, colIndex) => {
              return { width: "10%" };
            },
          },
         {
           dataField: "free_cost_price",
           text: props.t("Price (QR)"),
             formatter: (cell,row)=>{
               return row?.free_cost_price
           },
           sort: true,
           headerStyle: (colum, colIndex) => {
             return { width: "8%" };
           },
         },
         {
           dataField: "projected_cost",
           text: props.t("Cost"),
           formatter: (cell, row) => {
               return row?.projected_cost
           },
           sort: true,
           headerStyle: (colum, colIndex) => {
             return { width: "8%" };
           },
         },
     
         {
           dataField: "transaction_date",
           text: props.t("Date"),
           formatter: (cell, row) => {
             return moment(row.transaction_date).format(
               "DD/MM/YYYY HH:mm"
             );
           },
           sort: true,
           headerStyle: (colum, colIndex) => {
             return { width: "14%" };
           },
         },
    ];
}